import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../../components/Footer';
export function PrivacyPolicyPage() {
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-4290">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-4291">
        <Link to="/" className="flex items-center gap-2" data-id="element-4292">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-4293"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-4294">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-4xl mx-auto px-6 py-12" data-id="element-4295">
        <h1 className="text-4xl font-bold mb-4" data-id="element-4296">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8 font-mono" data-id="element-4297">
          Last Updated: {new Date().toLocaleDateString()}
        </p>

        <div className="bg-white border border-gray-300 p-8 space-y-8" data-id="element-4298">
          <section data-id="element-4299">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4300">1. Introduction</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4301">
              Citiplots Private Limited ("we", "us", "our") is committed to
              protecting your privacy. This Privacy Policy explains how we
              collect, use, disclose, and safeguard your information when you
              use our platform at Citiplots.com.
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-4302">
              By using our services, you consent to the data practices described
              in this policy. If you do not agree with this policy, please
              discontinue use of our platform immediately.
            </p>
          </section>

          <section data-id="element-4303">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4304">
              2. Information We Collect
            </h2>

            <h3 className="text-lg font-bold mb-2" data-id="element-4305">2.1 Personal Information</h3>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4306">
              We collect information that identifies you personally, including:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-4" data-id="element-4307">
              <li data-id="element-4308">Name, email address, phone number</li>
              <li data-id="element-4309">Postal address and location data</li>
              <li data-id="element-4310">
                Government-issued identification (PAN, Aadhaar, Passport for
                NRIs)
              </li>
              <li data-id="element-4311">
                Financial information (bank account details for transactions)
              </li>
              <li data-id="element-4312">Property ownership documents</li>
              <li data-id="element-4313">Professional information (for developers and authorities)</li>
            </ul>

            <h3 className="text-lg font-bold mb-2" data-id="element-4314">2.2 Usage Data</h3>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4315">
              We automatically collect certain information when you use our
              platform:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-4" data-id="element-4316">
              <li data-id="element-4317">IP address, browser type, and device information</li>
              <li data-id="element-4318">Pages visited, time spent, and click patterns</li>
              <li data-id="element-4319">Search queries and filter preferences</li>
              <li data-id="element-4320">Geolocation data (with your permission)</li>
              <li data-id="element-4321">Cookies and similar tracking technologies</li>
            </ul>

            <h3 className="text-lg font-bold mb-2" data-id="element-4322">2.3 Communication Data</h3>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4323">
              We collect and store:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4324">
              <li data-id="element-4325">Messages exchanged between buyers and sellers</li>
              <li data-id="element-4326">Email correspondence with our support team</li>
              <li data-id="element-4327">Phone call recordings (with notice and consent)</li>
              <li data-id="element-4328">Reviews and ratings you provide</li>
            </ul>
          </section>

          <section data-id="element-4329">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4330">
              3. How We Use Your Information
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4331">
              We use collected information for the following purposes:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4332">
              <li data-id="element-4333">
                <strong data-id="element-4334">Service Delivery:</strong> To facilitate property
                transactions, verify identities, and process payments
              </li>
              <li data-id="element-4335">
                <strong data-id="element-4336">Communication:</strong> To respond to inquiries, send
                notifications, and provide customer support
              </li>
              <li data-id="element-4337">
                <strong data-id="element-4338">Personalization:</strong> To recommend relevant
                properties and customize your experience
              </li>
              <li data-id="element-4339">
                <strong data-id="element-4340">Security:</strong> To detect fraud, prevent abuse, and
                ensure platform safety
              </li>
              <li data-id="element-4341">
                <strong data-id="element-4342">Legal Compliance:</strong> To comply with Indian laws
                including FEMA, RERA, and data protection regulations
              </li>
              <li data-id="element-4343">
                <strong data-id="element-4344">Analytics:</strong> To understand usage patterns and
                improve our services
              </li>
              <li data-id="element-4345">
                <strong data-id="element-4346">Marketing:</strong> To send promotional materials (with
                opt-out option)
              </li>
            </ul>
          </section>

          <section data-id="element-4347">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4348">
              4. Information Sharing and Disclosure
            </h2>

            <h3 className="text-lg font-bold mb-2" data-id="element-4349">4.1 With Other Users</h3>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4350">
              When you create a listing or make an inquiry, certain information
              is shared with relevant parties to facilitate transactions.
            </p>

            <h3 className="text-lg font-bold mb-2" data-id="element-4351">
              4.2 With Service Providers
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4352">
              We share data with trusted third parties who assist us:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-4" data-id="element-4353">
              <li data-id="element-4354">Payment processors (Razorpay, Stripe)</li>
              <li data-id="element-4355">Cloud storage providers (AWS, Google Cloud)</li>
              <li data-id="element-4356">Email and SMS service providers</li>
              <li data-id="element-4357">Analytics platforms (Google Analytics)</li>
              <li data-id="element-4358">Document verification services</li>
            </ul>

            <h3 className="text-lg font-bold mb-2" data-id="element-4359">4.3 Legal Requirements</h3>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4360">
              We may disclose your information when required by law, court
              order, or government authority, or to protect our legal rights.
            </p>

            <h3 className="text-lg font-bold mb-2" data-id="element-4361">4.4 Business Transfers</h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4362">
              In the event of a merger, acquisition, or sale of assets, your
              information may be transferred to the acquiring entity.
            </p>
          </section>

          <section data-id="element-4363">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4364">5. Data Security</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4365">
              We implement industry-standard security measures to protect your
              data:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4366">
              <li data-id="element-4367">SSL/TLS encryption for data transmission</li>
              <li data-id="element-4368">Encrypted storage of sensitive information</li>
              <li data-id="element-4369">Regular security audits and penetration testing</li>
              <li data-id="element-4370">Access controls and authentication mechanisms</li>
              <li data-id="element-4371">Employee training on data protection</li>
              <li data-id="element-4372">Incident response procedures</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4" data-id="element-4373">
              However, no method of transmission over the internet is 100%
              secure. We cannot guarantee absolute security of your data.
            </p>
          </section>

          <section data-id="element-4374">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4375">
              6. Your Rights and Choices
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4376">
              You have the following rights regarding your personal information:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4377">
              <li data-id="element-4378">
                <strong data-id="element-4379">Access:</strong> Request a copy of your personal data
              </li>
              <li data-id="element-4380">
                <strong data-id="element-4381">Correction:</strong> Update or correct inaccurate
                information
              </li>
              <li data-id="element-4382">
                <strong data-id="element-4383">Deletion:</strong> Request deletion of your account and
                data (subject to legal obligations)
              </li>
              <li data-id="element-4384">
                <strong data-id="element-4385">Portability:</strong> Receive your data in a structured,
                machine-readable format
              </li>
              <li data-id="element-4386">
                <strong data-id="element-4387">Opt-Out:</strong> Unsubscribe from marketing
                communications
              </li>
              <li data-id="element-4388">
                <strong data-id="element-4389">Cookies:</strong> Manage cookie preferences through
                browser settings
              </li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4" data-id="element-4390">
              To exercise these rights, contact us at privacy@citiplots.com
            </p>
          </section>

          <section data-id="element-4391">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4392">7. Data Retention</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-4393">
              We retain your personal information for as long as necessary to
              provide services and comply with legal obligations. Transaction
              records are maintained for 7 years as required by Indian law.
              After account deletion, we may retain anonymized data for
              analytics purposes.
            </p>
          </section>

          <section data-id="element-4394">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4395">
              8. International Data Transfers
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-4396">
              For NRI users, your data may be transferred to and processed in
              India. We ensure appropriate safeguards are in place for such
              transfers, including standard contractual clauses and compliance
              with applicable data protection laws.
            </p>
          </section>

          <section data-id="element-4397">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4398">9. Children's Privacy</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-4399">
              Our services are not intended for individuals under 18 years of
              age. We do not knowingly collect personal information from
              children. If we become aware of such collection, we will delete
              the information immediately.
            </p>
          </section>

          <section data-id="element-4400">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4401">
              10. Changes to This Policy
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-4402">
              We may update this Privacy Policy periodically. Material changes
              will be notified via email or prominent notice on our platform.
              The "Last Updated" date at the top indicates when the policy was
              last revised.
            </p>
          </section>

          <section data-id="element-4403">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4404">11. Contact Us</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4405">
              For questions about this Privacy Policy or to exercise your
              rights, contact:
            </p>
            <div className="p-4 bg-gray-50 border border-gray-200" data-id="element-4406">
              <p className="font-mono text-sm" data-id="element-4407">
                <strong data-id="element-4408">Data Protection Officer</strong>
                <br data-id="element-4409" />
                Citiplots Private Limited
                <br data-id="element-4410" />
                Email: privacy@citiplots.com
                <br data-id="element-4411" />
                Phone: +91-XXX-XXX-XXXX
                <br data-id="element-4412" />
                Address: [Company Registered Address]
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer data-id="element-4413" />
    </div>;
}